import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { change } from 'redux-form';
import _ from 'lodash';
import { Icon, Popup, Checkbox } from 'semantic-ui-react';
import { connect } from 'react-redux';

import {
  createToast,
  toastType,
  successToast,
  errorToast,
} from 'Common/ToastHelper';
import { Base64Image } from 'Common/Components/Base64Image/Base64Image';
import { RecipeFieldEnum as Fields, FieldEnum } from 'Common/FieldEnum';
import ReactTable from 'Common/ReactTableWrapper';
import {
  REACT_TABLE_ROW_COLORS,
  ReactTableWrapperColumnProperties,
  NOTIFICATION_DIALOG_MESSAGES,
} from 'Common/Constants';
import { GridContextMenu } from 'Components/app/contextmenu/ContextMenuManager';
import {
  COMPONENTS,
  COMPONENT_TYPE,
} from 'Common/Components/NutritionalHover/constants/constants';
import { NutritionalHoverConnected } from 'Common/Components/NutritionalHover/NutritionalHover';
import { SelectFilter, SelectFilterMethod } from 'Common/GridHelper';
import { GridEnum } from 'Common/Constants/Enumeration/GridEnum';
import { makeOptionsWithNull } from 'Common/FormHelper';
import * as RecipeActions from 'Pages/managerecipe/state/editrecipe/actions';
import * as RecipeSelectors from 'Pages/managerecipe/state/editrecipe/selectors';
import * as DialogActions from 'Components/dialogs/state/actions';
import { labels as allergenLabels } from 'Common/Components/Allergens/Allergens'

import { DELETE_RECIPE_SCENARIOS } from './Constants';

const componentTypeOptions = makeOptionsWithNull(
  Object.entries(COMPONENT_TYPE).map(([key, value]) => ({
    Id: value,
    Description: key,
  }))
);

class RecipeTable extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    data: PropTypes.array,
    selectable: PropTypes.bool,
    fieldName: PropTypes.string,
    formName: PropTypes.string,
    disableViewEditDelete: PropTypes.bool,
    recipeCategories: PropTypes.array.isRequired,
    recipeCategoriesMap: PropTypes.object.isRequired,
    recipeSourcesMap: PropTypes.object.isRequired,
    recipeSources: PropTypes.array.isRequired,
    recipeGroupsMap: PropTypes.object.isRequired,
    recipeGroups: PropTypes.array.isRequired,
    recipeHACCPMap: PropTypes.object.isRequired,
    recipeHACCP: PropTypes.array.isRequired,
  };

  static defaultProps = {
    loading: false,
    selectable: false,
    disableViewEditDelete: false,
    data: [],
  };

  selectedRecipeId = null;

  reactTableRef = createRef();

  state = {
    page: 0,
    isAllChecked: false,
    selectedRecipeIds: [],
    data: [],
  };

  handlePageChange = (newPage) => {
    this.setState({ page: newPage });
  };

  handleSelectAllClick = () => {
    const { formName, fieldName, change } = this.props;
    const { selectedRecipeIds } = this.state;

    let newSelectedRecipeIds = [];
    let newData = _.cloneDeep(this.state.data);

    const shownRecipeIds = this.reactTableRef.current.state.sortedData
      .map((x) => x._original)
      .map((x) => x.Id);

    //handle check all with no filters
    if (shownRecipeIds.length === newData.length) {
      if (this.areSomeOrNoneSelected()) {
        newSelectedRecipeIds = shownRecipeIds;
        newData = newData.map((x) => {
          return { ...x, Selected: true };
        });
      } else {
        newData = newData.map((x) => {
          return { ...x, Selected: false };
        });
      }
    }
    //handle check all with filters
    else {
      newSelectedRecipeIds = _.cloneDeep(selectedRecipeIds);
      //handle uncheck all (all visible data with filters already checked ) with filters
      if (shownRecipeIds.every((id) => newSelectedRecipeIds.includes(id))) {
        shownRecipeIds.forEach((shownId) => {
          newData[
            newData.indexOf(newData.filter((x) => x.Id === shownId)[0])
          ].Selected = false;
          newSelectedRecipeIds.splice(newSelectedRecipeIds.indexOf(shownId), 1);
        });
      }
      //handle some and none checked with filters
      else {
        shownRecipeIds.forEach((id) => {
          if (!selectedRecipeIds.includes(id)) {
            newData[
              newData.indexOf(newData.filter((x) => x.Id === id)[0])
            ].Selected = true;
            newSelectedRecipeIds.push(id);
          }
        });
      }
    }

    this.setState({
      isAllChecked: newSelectedRecipeIds.length === newData.length,
      selectedRecipeIds: newSelectedRecipeIds,
      data: newData,
    });

    change(formName, fieldName, newSelectedRecipeIds);
  };

  areSomeOrNoneSelected = () => {
    const { selectedRecipeIds } = this.state;
    const { data } = this.props;
    return (
      (selectedRecipeIds.length > 0 &&
        data.length !== selectedRecipeIds.length) ||
      selectedRecipeIds.length === 0
    );
  };

  handleSelectRecipe = (row, selected) => {
    const { isAllChecked, selectedRecipeIds, data } = this.state;
    const { formName, fieldName, change } = this.props;

    const dataIndex = data.indexOf(data.filter((x) => x.Id === row.Id)[0]);

    let selectedRecipeIdsCopy = _.cloneDeep(selectedRecipeIds);
    const newData = _.cloneDeep(data);

    if (selected) {
      newData[dataIndex].Selected = true;
      selectedRecipeIdsCopy.unshift(row.Id);

      change(formName, fieldName, selectedRecipeIdsCopy);

      let allChecked = isAllChecked;

      if (selectedRecipeIdsCopy.length === newData.length) {
        allChecked = true;
      }

      this.setState({
        selectedRecipeIds: selectedRecipeIdsCopy,
        data: newData,
        isAllChecked: allChecked,
      });
    } else {
      newData[dataIndex].Selected = false;
      selectedRecipeIdsCopy = selectedRecipeIdsCopy.filter((x) => x !== row.Id);
      this.setState({
        selectedRecipeIds: selectedRecipeIdsCopy,
        data: newData,
        isAllChecked: false,
      });
      change(formName, fieldName, selectedRecipeIdsCopy);
    }
  };

  componentDidMount() {
    const { data, selectable } = this.props;

    if (data.length) {
      let newData = _.cloneDeep(data);
      if (selectable) {
        newData = newData.map((x) => {
          return { ...x, Selected: false };
        });
      }
      this.setState({ data: newData });
    }
  }

  componentDidUpdate(prevProps) {
    const { prevDeleteError, prevDuplicateError } = prevProps;
    const {
      deleteError,
      setDeleteSuccessful,      
      duplicateSuccessful,
      duplicateError,
      setDuplicateSuccessful,      
      setInactiveSuccessful,
      resetDeleteError,
      resetDuplicateError,
      resetInactiveError,
      data,
    } = this.props;

    const { selectedRecipeIds } = this.state;

    if (data !== prevProps.data) {
      let newData = _.cloneDeep(data);
      const selectedRecipeIdsCopy = _.cloneDeep(selectedRecipeIds);
      if (this.props.selectable) {
        newData = newData.map((x) => {
          return {
            ...x,
            Selected: selectedRecipeIdsCopy.includes(x.Id),
          };
        });
      }
      this.setState({ data: newData });
    }

    if (prevDeleteError !== deleteError && deleteError) {
      this.handleError(deleteError, this.selectedRecipeId);
      resetDeleteError();
    }

    successToast(
      this.props,
      prevProps,
      'deleteSuccessful',
      'Recipe Deleted!',
      () => setDeleteSuccessful(false)
    );

    if (prevDuplicateError !== duplicateError && duplicateError) {
      this.handleError(duplicateError, this.selectedRecipeId);
      resetDuplicateError();
    }

    successToast(
      this.props,
      prevProps,
      'duplicateSuccessful',
      'Recipe Duplicated!',
      () => {
        setDuplicateSuccessful(null);
        const { history } = this.props;
        history.push(`/managerecipe/edit/${duplicateSuccessful}`);
      }
    );

    successToast(
      this.props,
      prevProps,
      'inactiveSuccessful',
      'Recipe Inactive!',
      () => setInactiveSuccessful(false)
    );

    errorToast(this.props, prevProps, 'inactiveError', resetInactiveError);
  }

  handleError = (error, recipeId) => {
    const { setNotificationDialog } = this.props;

    if (_.isNil(error.Scenario)) {
      return createToast(toastType.error, error.Title, error.Message, false);
    }

    let dialog = null;

    switch (error.Scenario) {
      case DELETE_RECIPE_SCENARIOS.NOTIFY:
        dialog = {
          ...NOTIFICATION_DIALOG_MESSAGES.DELETE_RECIPE_SCENARIO_1,
          title: error.Title,
          message: error.Message,
        };
        break;
      case DELETE_RECIPE_SCENARIOS.ALLOW_SET_INACTIVE:
        dialog = {
          ...NOTIFICATION_DIALOG_MESSAGES.DELETE_RECIPE_SCENARIO_2,
          title: error.Title,
          message: `${error.Message} Would you like to set recipe to Inactive?`,
          actionsToDispatchOnOk: [
            RecipeActions.writeRecipeInactive(recipeId, true),
          ],
        };
        break;
      default:
        dialog.showCancel = false;
        break;
    }

    if (dialog) {
      setNotificationDialog(dialog);
    }
  };

  onEditRecipeClick = (row) => {
    const { history } = this.props;
    history.push(`/managerecipe/edit/${row.Id}`);
  };

  onDeleteRecipe = (row) => {
    const { setNotificationDialog } = this.props;
    this.selectedRecipeId = row.Id;
    setNotificationDialog({
      ...NOTIFICATION_DIALOG_MESSAGES.DELETE_RECIPE_CONFIRM,
      message: `Are you sure you want to delete ${row.Id}?`,
      actionsToDispatchOnOk: [RecipeActions.deleteRecipe(row.Id)],
    });
  };

  onDuplicateRecipe = (row) => {
    const { setNotificationDialog } = this.props;
    this.selectedRecipeId = row.Id;
    setNotificationDialog({
      ...NOTIFICATION_DIALOG_MESSAGES.DUPLICATE_RECIPE_CONFIRM,
      message: `Are you sure you want to duplicate ${row.Id}?`,
      actionsToDispatchOnOk: [RecipeActions.duplicateRecipe(row.Id)],
    });
  };

  menuOptions = [
    {
      icon: 'pencil',
      text: 'View/Edit',
      handler: this.onEditRecipeClick,
    },
    {
      icon: 'copy',
      text: 'Duplicate',
      handler: this.onDuplicateRecipe
    },
    {
      icon: 'trash',
      text: 'Delete',
      className: 'danger',
      handler: this.onDeleteRecipe,
      disabledWhen: (row) => row[FieldEnum.IsReadOnly],
    },
  ];

  columns = [
    ...(this.props.selectable
      ? [
          {
            Header: () => {
              return (
                <Checkbox
                  checked={this.state.isAllChecked}
                  onClick={this.handleSelectAllClick}
                  indeterminate={
                    this.state.selectedRecipeIds.length > 0 &&
                    this.props.data.length !==
                      this.state.selectedRecipeIds.length
                  }
                />
              );
            },
            accessor: Fields.Selected,
            style: { textAlign: 'center' },
            Cell: (rowInfo) => {
              return (
                <Checkbox
                  onClick={(e, data) => {
                    this.handleSelectRecipe(rowInfo.original, data.checked);
                  }}
                  checked={rowInfo.original.Selected}
                />
              );
            },
          },
        ]
      : []),
    {
      Header: 'Images',
      accessor: Fields.Picture,
      style: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
      Cell: ({ row }) => (
        <NutritionalHoverConnected
          recipeId={row[Fields.Id]}
          showDisclaimer={false}
          showServingCost={true}
          openDelay={1000}
        >
          <Base64Image
            style={{ height: 25, width: 'auto' }}
            fluid
            src={row[Fields.Picture]}
          />
        </NutritionalHoverConnected>
      ),
      width: 80,
      sortable: false,
      filterable: false,
      resizable: false,
      show: true,
      visibility: true,
    },
    {
      Header: 'Recipe ID',
      accessor: Fields.Id,
      ...ReactTableWrapperColumnProperties,
    },

    {
      Header: 'Menu Name',
      accessor: Fields.Name,
      ...ReactTableWrapperColumnProperties,
      Cell: ({ row }) => {
        return (
          <Popup
            trigger={<span>{row[Fields.Name]}</span>}
            content={row[Fields.Name]}
            on="hover"
          />
        );
      },
    },
    {
      Header: 'Recipe Name',
      accessor: Fields.Description,
      ...ReactTableWrapperColumnProperties,
      Cell: ({ row }) => {
        return (
          <Popup
            trigger={<span>{row[Fields.Description]}</span>}
            content={row[Fields.Description]}
            on="hover"
          />
        );
      },
    },
    {
      Header: 'Serving Size',
      accessor: Fields.ServingSize,
      ...ReactTableWrapperColumnProperties,
      Cell: ({ row }) => {
        return (
          <Popup
            trigger={<span>{row[Fields.ServingSize]}</span>}
            content={row[Fields.ServingSize]}
            on="hover"
          />
        );
      },
    },
    {
      Header: 'Allergens',
      accessor: Fields.Allergens,
      ...ReactTableWrapperColumnProperties,
      filterMethod: (filter, row) => {
        const allergens = row[filter.id].map(i => i.Description.toLowerCase());
        const filtervalue = String(filter.value).toLowerCase();
        if(allergens.length){
          return allergens.some(i => i.startsWith(filtervalue));
        }

        row._original[Fields.NoAllergens] && allergens.push(allergenLabels[Fields.NoAllergens].toLowerCase());
        row._original[Fields.AllergensNotAvailable] && allergens.push(allergenLabels[Fields.AllergensNotAvailable].toLowerCase());

        return allergens.some(i => i.startsWith(filtervalue));
      }, 
      Cell: (props) => {
        const {row, original} = props;
        const allergens = row[Fields.Allergens].length
          ? row[Fields.Allergens].map(a => a.Description).join(', ')
          : original[Fields.NoAllergens]
            ? allergenLabels[Fields.NoAllergens]
            : original[Fields.AllergensNotAvailable]
              ? allergenLabels[Fields.AllergensNotAvailable]
              : '';
        return (
          <Popup
            trigger={<span>{allergens}</span>}
            content={allergens}
            on="hover"
          />
        );
      },
      show: false,
    },
    {
      Header: 'Attributes',
      accessor: Fields.Attributes,
      ...ReactTableWrapperColumnProperties,
      filterMethod:  (filter, row) => row[filter.id].some(i => i.Description.toLowerCase().startsWith(String(filter.value).toLowerCase())),
      Cell: ({ row }) => {
        const attributes = row[Fields.Attributes].map(a => a.Description).join(', ');
        return (
          <Popup
            trigger={<span>{attributes}</span>}
            content={attributes}
            on="hover"
          />
        );
      },
      show: false,
    },
    {
      Header: 'Imported Recipe Code',
      accessor: Fields.ImportedRecipeCode,
      ...ReactTableWrapperColumnProperties,
    },
    {
      Header: 'Source',
      accessor: Fields.RecipeSourceId,
      filterMethod: SelectFilterMethod,
      Filter: (props) => (
        <SelectFilter
          {...props}
          options={makeOptionsWithNull(this.props.recipeSources)}
        />
      ),
      Cell: ({ row }) => {
        const description = _.get(
          this.props.recipeSourcesMap,
          [row[Fields.RecipeSourceId], 'Description'],
          ''
        );
        return (
          <Popup
            trigger={<span>{description}</span>}
            content={description}
            on="hover"
          />
        );
      },
      width: 140,
      ...ReactTableWrapperColumnProperties,
    },
    {
      Header: 'Recipe Category',
      accessor: Fields.RecipeCategoryId,
      filterMethod: SelectFilterMethod,
      Filter: (props) => (
        <SelectFilter
          {...props}
          options={makeOptionsWithNull(this.props.recipeCategories)}
        />
      ),
      Cell: ({ row }) => {
        const description = _.get(
          this.props.recipeCategoriesMap,
          [row[Fields.RecipeCategoryId], 'Description'],
          ''
        );
        return (
          <Popup
            trigger={<span>{description}</span>}
            content={description}
            on="hover"
          />
        );
      },
      width: 140,
      ...ReactTableWrapperColumnProperties,
      show: false,
    },
    {
      Header: 'Recipe Group',
      accessor: Fields.GroupId,
      filterMethod: SelectFilterMethod,
      Filter: (props) => (
        <SelectFilter
          {...props}
          options={makeOptionsWithNull(this.props.recipeGroups)}
        />
      ),
      Cell: ({ row }) => {
        const description = _.get(
          this.props.recipeGroupsMap,
          [row[Fields.GroupId], 'Description'],
          ''
        );
        return (
          <Popup
            trigger={<span>{description}</span>}
            content={description}
            on="hover"
          />
        );
      },
      width: 140,
      ...ReactTableWrapperColumnProperties,
      show: false,
    },
    {
      Header: 'Shared With',
      accessor: Fields.SharedWith,
      ...ReactTableWrapperColumnProperties,
      show: false,
    },
    {
      Header: '# Servings',
      accessor: Fields.NumberOfPortion,
      ...ReactTableWrapperColumnProperties,
      show: false,
    },
    {
      id: Fields.ComponentSummary,
      Header: 'Component Summary',
      accessor: (row) => {
        const summary = Object.entries(COMPONENTS)
          .filter(([key, value]) => Number(row[key]) > 0)
          .map(([key, value]) => value)
          .join(', ');
        return summary;
      },
      Cell: ({ row }) => (
        <Popup
          trigger={<span>{row[Fields.ComponentSummary]}</span>}
          content={row[Fields.ComponentSummary]}
          on="hover"
        />
      ),
      ...ReactTableWrapperColumnProperties,
      show: false,
    },
    ...Object.entries(COMPONENTS).map(([key, value]) => ({
      Header: value,
      accessor: key,
      ...ReactTableWrapperColumnProperties,
      show: false,
    })),
    {
      Header: 'Component Type',
      accessor: Fields.ComponentType,
      ...ReactTableWrapperColumnProperties,
      show: false,
      filterMethod: SelectFilterMethod,
      Filter: (props) => (
        <SelectFilter {...props} options={componentTypeOptions} />
      ),
      Cell: ({ row }) => {
        const component = Object.entries(COMPONENT_TYPE).find(
          ([key, value]) => row[Fields.ComponentType] === value
        );

        return component && <span>{component[0]}</span>;
      },
    },
    {
      Header: 'Allergens Verified',
      accessor: Fields.AllergensVerified,
      style: {
        textAlign: 'center',
      },
      Cell: ({ row }) => {
        const verified = row[Fields.AllergensVerified];
        return verified && <Icon size="small" color="green" name="check" />;
      },
      ...ReactTableWrapperColumnProperties,
      show: false,
    },
    {
      Header: 'HACCP Category',
      accessor: Fields.HACCPId,
      filterMethod: SelectFilterMethod,
      Filter: (props) => (
        <SelectFilter
          {...props}
          options={makeOptionsWithNull(this.props.recipeHACCP)}
        />
      ),
      Cell: ({ row }) => {
        const description = _.get(
          this.props.recipeHACCPMap,
          [row[Fields.HACCPId], 'Description'],
          ''
        );
        return (
          <Popup
            trigger={<span>{description}</span>}
            content={description}
            on="hover"
          />
        );
      },
      ...ReactTableWrapperColumnProperties,
      show: false,
    },
    {
      Header: 'Date Created',
      accessor: Fields.DateCreated,
      ...ReactTableWrapperColumnProperties,
      show: false,
    },
    {
      Header: 'Date Modified',
      accessor: Fields.DateModified,
      ...ReactTableWrapperColumnProperties,
      show: false,
    },
    {
      width: 50,
      fixed: 'right',
      Cell: (gridProps) => {
        if (!this.props.disableViewEditDelete) {
          return GridContextMenu({
            gridProps,
            options: this.menuOptions,
          });
        } else {
          return GridContextMenu({
            gridProps,
            options: [],
          });
        }
      },
    },
  ];

  getTrProps = (state, rowInfo, column) => {
    const isInactive = _.get(rowInfo, ['original', Fields.Inactive]) === true;
    const isUsedOnMenu =
      _.get(rowInfo, ['original', Fields.UsedOnMenu]) === true;

    const style = {};

    if (isUsedOnMenu) {
      style.color = REACT_TABLE_ROW_COLORS.USED_ON_MENU;
    }

    if (isInactive) {
      style.color = REACT_TABLE_ROW_COLORS.INACTIVE;
    }
   

    return {
      style,
    };
  };

  get loading() {
    const { loading, deleteFetching, inactiveFetching } = this.props;
    return loading || deleteFetching || inactiveFetching;
  }

  render() {
    const { loading } = this;
    const { data, page } = this.state;
    return (
      <ReactTable
        className="-striped -highlight"
        gridName={GridEnum.MNU_Manage_Recipe_View}
        loading={loading}
        data={data}
        columns={this.columns}
        draggableColumns={true}
        showHideColumn={true}
        menu="hasCogs"
        getTrProps={this.getTrProps}
        page={page}
        onPageChange={this.handlePageChange}
        reactTableRef={this.reactTableRef}
      />
    );
  }
}

const mapStateToProps = (state) => ({  
  duplicateSuccessful: RecipeSelectors.getDuplicateSuccessful(state),
  duplicateError: RecipeSelectors.getDuplicateError(state),
  deleteSuccessful: RecipeSelectors.getDeleteSuccessful(state),
  deleteError: RecipeSelectors.getDeleteError(state),
  deleteFetching: RecipeSelectors.getDeleteFetching(state),
  inactiveSuccessful: RecipeSelectors.getInactiveSuccessful(state),
  inactiveError: RecipeSelectors.getInactiveError(state),
  inactiveFetching: RecipeSelectors.getInactiveFetching(state),
});

const mapDispatchToProps = {
  resetDeleteError: RecipeActions.resetDeleteError,
  setDeleteSuccessful: RecipeActions.setDeleteSuccessful,
  resetDuplicateError: RecipeActions.resetDuplicateError,
  setDuplicateSuccessful: RecipeActions.setDuplicateSuccessful,
  setNotificationDialog: DialogActions.setNotificationDialog,
  setInactiveSuccessful: RecipeActions.setInactiveSuccessful,
  resetInactiveError: RecipeActions.resetInactiveError,
  change,
};

RecipeTable = connect(mapStateToProps, mapDispatchToProps)(RecipeTable);

export { RecipeTable };



// WEBPACK FOOTER //
// ./src/common/Components/RecipeTable/RecipeTable.js